import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5f9c2c6c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "holder holder-fluid"
};
const _hoisted_3 = {
  class: "line"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "Подборки", -1));

const _hoisted_5 = {
  class: "search"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "search-button"
}, null, -1));

const _hoisted_7 = {
  class: "catalog catalog-category"
};
const _hoisted_8 = {
  class: "catalog-item"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "catalog-cover"
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Перейти ");

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.6471 9.24984L10.6327 5.55143L11.649 4.44824L17.0762 9.44824L17.675 9.99984L17.0762 10.5514L11.649 15.5514L10.6327 14.4482L14.6471 10.7498H3V9.24984H14.6471Z",
  fill: "black"
})], -1));

const _hoisted_13 = {
  class: "catalog-author"
};
const _hoisted_14 = {
  class: "catalog-name"
};
const _hoisted_15 = {
  key: 0,
  class: "pagination"
};
const _hoisted_16 = {
  class: "pagination-text"
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode("Страница ");

const _hoisted_18 = {
  class: "pagination-list"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "pagination-arrows"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _directive_img = _resolveDirective("img");

  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("input", {
    type: "text",
    class: "search-input",
    placeholder: "Поиск",
    onChange: _cache[0] || (_cache[0] = $event => $data.search = $event.target.value)
  }, null, 32), _hoisted_6])]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.compilations, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "catalog-col",
      key: item.id
    }, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_router_link, {
      class: "catalog-img",
      style: {
        "cursor": "pointer"
      },
      to: {
        name: 'compilation',
        params: {
          id: item.id
        }
      }
    }, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: item.thumbWithPath,
        alt: ""
      }, null, 8, _hoisted_9), _createElementVNode("div", _hoisted_10, [_createVNode(_component_router_link, {
        to: {
          name: 'compilation',
          params: {
            id: item.id
          }
        },
        class: "catalog-cover-more",
        style: {
          "cursor": "pointer"
        }
      }, {
        default: _withCtx(() => [_hoisted_11, _hoisted_12]),
        _: 2
      }, 1032, ["to"])])]),
      _: 2
    }, 1032, ["to"])])), [[_directive_img, {
      classes: ['.catalog-img img']
    }]]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_router_link, {
      style: {
        "cursor": "pointer"
      },
      to: {
        name: 'compilation',
        params: {
          id: item.id
        }
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
      _: 2
    }, 1032, ["to"])]), _createElementVNode("div", _hoisted_14, _toDisplayString(item.description), 1)]);
  }), 128))]), $data.PaginationMeta && $data.PaginationMeta.pageCount ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("b", null, _toDisplayString($data.PaginationMeta.currentPage), 1), _createTextVNode(" из " + _toDisplayString($data.PaginationMeta.pageCount), 1)]), _createElementVNode("ul", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.PaginationMeta.pageCount, number => {
    return _openBlock(), _createElementBlock("li", {
      key: 'numberPage-' + number
    }, [_createElementVNode("a", {
      style: {
        "cursor": "pointer"
      },
      onClick: $event => $options.changePage(number),
      class: _normalizeClass({
        'active': number === $data.PaginationMeta.currentPage
      })
    }, _toDisplayString(number), 11, _hoisted_19)]);
  }), 128))]), _createElementVNode("div", _hoisted_20, [_createElementVNode("a", {
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[1] || (_cache[1] = $event => $options.changePage($data.PaginationMeta.currentPage - 1)),
    class: "pagination-prev"
  }), _createElementVNode("a", {
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[2] || (_cache[2] = $event => $options.changePage($data.PaginationMeta.currentPage + 1)),
    class: "pagination-next"
  })])])) : _createCommentVNode("", true)])]);
}